import {ChangeDetectionStrategy, Component, computed, input, output} from "@angular/core";
import {MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {UserDTO} from "@menu-api";
import {ROLE_NAMES} from "@menu-security";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
    selector: "app-profile-button",
    imports: [
        MatIcon,
        TranslatePipe,
        MatIconButton,
    ],
    templateUrl: "./profile-button.component.html",
    styleUrl: "./profile-button.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileButtonComponent {
    public readonly user = input.required<UserDTO>();
    public readonly logout = output();

    protected readonly short = computed(() => this.user().name.split(" ").map(([first]) => first.toUpperCase()).join(""));
    protected readonly roleKey = computed(() => ROLE_NAMES.get(this.user().role)?.translationKey ?? "");
}
